import { useState } from 'react';
import DefaultTestCard from '../../features/tests/components/cards/DefaultTestCard';
import MobileTestCardRcd from '../../features/tests/components/cards/MobileTestCardRcd';
import MobileTestCardDistributionBoard from '../../features/tests/components/cards/MobileTestCardDistributionBoard';
import MobileAssetGroupDefault from '../../features/tests/components/cards/MobileAssetGroupDefault';
import MobileAssetGroupEmerg from '../../features/tests/components/cards/MobileAssetGroupEmerg';
import { Category, Section, ColumnLabel } from './galleryPrimitives';

const columnStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  minWidth: 0,
};

const columnTitleStyle = {
  margin: 0,
  fontSize: 'var(--text-sm)',
  fontWeight: 700,
  color: 'var(--text-secondary)',
};

/** Four-column mobile test card demos: default, RCD, DB, asset groups. */
export default function MobileTestCardsGallery() {
  const [cardResult, setCardResult] = useState(null);
  const [rcdPush, setRcdPush] = useState('pass');
  const [rcdTrip, setRcdTrip] = useState('0');
  const [dbResult, setDbResult] = useState(null);
  const [assetGroupOpen, setAssetGroupOpen] = useState(false);

  return (
    <Category id="mobile-test-cards" title="Mobile test cards">
    <Section name="Mobile Test Cards" file="features/tests/components/cards/*">
      <div
        style={{
          display: 'grid',
          gap: '1.5rem',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          alignItems: 'start',
        }}
      >
        <div style={columnStyle}>
          <h3 style={columnTitleStyle}>Default</h3>
          <ColumnLabel>interactive</ColumnLabel>
          <DefaultTestCard
            equipmentCode="1"
            make="Stanlite"
            model="Wall Mount"
            location="B00K - R0007"
            result={cardResult}
            onResultChange={setCardResult}
            onEdit={() => {}}
          />
          <ColumnLabel>pass</ColumnLabel>
          <DefaultTestCard
            equipmentCode="1"
            make="Stanlite"
            model="Wall Mount"
            location="B00K - R0007"
            result="pass"
            onResultChange={() => {}}
            onEdit={() => {}}
          />
          <ColumnLabel>fail</ColumnLabel>
          <DefaultTestCard
            equipmentCode="1"
            make="Stanlite"
            model="Wall Mount"
            location="B00K - R0007"
            result="fail"
            onResultChange={() => {}}
            onEdit={() => {}}
          />
          <ColumnLabel>unselected</ColumnLabel>
          <DefaultTestCard
            equipmentCode="2"
            make="Stanlite"
            model="Wall Mount"
            location="B00K - R0008"
            result={null}
            onResultChange={() => {}}
            onEdit={() => {}}
          />
        </div>

        <div style={columnStyle}>
          <h3 style={columnTitleStyle}>RCDs</h3>
          <ColumnLabel>interactive</ColumnLabel>
          <MobileTestCardRcd
            circuitLabel="DB.1 – CB2"
            make="EATON"
            model="ELQ"
            rating="16A"
            pushResult={rcdPush}
            onPushResultChange={setRcdPush}
            tripTimeMs={rcdTrip}
            onTripTimeChange={setRcdTrip}
            onEdit={() => {}}
          />
          <ColumnLabel>fail</ColumnLabel>
          <MobileTestCardRcd
            circuitLabel="DB.1 – CB2"
            make="EATON"
            model="ELQ"
            rating="16A"
            pushResult="fail"
            onPushResultChange={() => {}}
            tripTimeMs="42"
            onTripTimeChange={() => {}}
            onEdit={() => {}}
          />
          <ColumnLabel>unselected</ColumnLabel>
          <MobileTestCardRcd
            circuitLabel="DB.1 – CB2"
            make="EATON"
            model="ELQ"
            rating="16A"
            pushResult={null}
            onPushResultChange={() => {}}
            tripTimeMs=""
            onTripTimeChange={() => {}}
            onEdit={() => {}}
          />
        </div>

        <div style={columnStyle}>
          <h3 style={columnTitleStyle}>Distribution boards</h3>
          <ColumnLabel>interactive</ColumnLabel>
          <MobileTestCardDistributionBoard
            boardCode="DB.1"
            make="EATON"
            model="N/a"
            location="B00B R0001"
            result={dbResult}
            onResultChange={setDbResult}
            onEdit={() => {}}
          />
          <ColumnLabel>pass</ColumnLabel>
          <MobileTestCardDistributionBoard
            boardCode="DB.1"
            make="EATON"
            model="N/a"
            location="B00B R0001"
            result="pass"
            onResultChange={() => {}}
            onEdit={() => {}}
          />
          <ColumnLabel>fail</ColumnLabel>
          <MobileTestCardDistributionBoard
            boardCode="DB.1"
            make="EATON"
            model="N/a"
            location="B00B R0001"
            result="fail"
            onResultChange={() => {}}
            onEdit={() => {}}
          />
          <ColumnLabel>unselected</ColumnLabel>
          <MobileTestCardDistributionBoard
            boardCode="DB.1"
            make="EATON"
            model="N/a"
            location="B00B R0001"
            result={null}
            onResultChange={() => {}}
            onEdit={() => {}}
          />
        </div>

        <div style={columnStyle}>
          <h3 style={columnTitleStyle}>Asset groups</h3>
          <ColumnLabel>default group</ColumnLabel>
          <MobileAssetGroupDefault
            groupCode="DB.1"
            assetType="Distribution Board"
            location="B00B R0001"
            testedCount={1}
            totalCount={8}
            expanded={assetGroupOpen}
            onClick={() => setAssetGroupOpen((open) => !open)}
          />
          <ColumnLabel>emerg idle</ColumnLabel>
          <MobileAssetGroupEmerg
            groupCode="BOOG"
            unitCount={4}
            testedCount={0}
            totalCount={4}
            status="idle"
            onStart={() => {}}
            onToggle={() => {}}
          />
          <ColumnLabel>emerg running</ColumnLabel>
          <MobileAssetGroupEmerg
            groupCode="BOOG"
            unitCount={4}
            testedCount={0}
            totalCount={4}
            status="running"
            remainingMs={(89 * 60 + 57) * 1000}
            onRequestReset={() => {}}
            onToggle={() => {}}
          />
          <ColumnLabel>emerg complete</ColumnLabel>
          <MobileAssetGroupEmerg
            groupCode="BOOG"
            unitCount={4}
            testedCount={4}
            totalCount={4}
            status="complete"
            remainingMs={0}
            onRequestReset={() => {}}
            onToggle={() => {}}
          />
        </div>
      </div>
    </Section>
    </Category>
  );
}
